import React from "react";
import styles from "./PFSCombinedAgents.module.css";
import ContentContainer from "../ContentContainer/ContentContainer";
import CAALogo from "./CAA_Stripe23-Web.png";
import { NavLink, useLocation } from "react-router-dom";
import { useBreadcrumb } from "../../hooks/useBreadcrumb";
import { PartnersIndexBreadcrumb } from "../PFSPartnersIndex/PFSPartnersIndex";

const PFSCombinedAgents = () => {
  const { pathname } = useLocation();

  useBreadcrumb([
    PartnersIndexBreadcrumb,
    {
      label: 'Combined Agents of America',
      url: pathname,
    },
  ]);

  return (
    <div className={styles.PfsCombinedAgents} data-testid="PFSCombinedAgents">
      <ContentContainer>
        <img className={styles.logo} src={CAALogo} alt="Combined Agents of America Logo" />
        <h1>Combined Agents of America Joins PFS Global as a Partner!</h1>
        <div className={styles.content}>
          <p>
            Combined Agents of America is an independent insurance agency network that was 
            established in 1997 through a collaborative effort among agencies in 
            Central Texas. Almost 30 years later, they have members across Arkansas, 
            Texas, Oklahoma, Kansas, Nebraska, Missouri, Colorado, Iowa, and 
            South Dakota, and also stand as one of the fastest-growing networks 
            in the industry.
          </p>
          <p>
            CAA has dedicated significant efforts to strengthen and enhance its 
            relationships with insurance companies and members, all while 
            preserving their independence and increasing each agency’s profitability.
          </p>
          <p>
            For more information about Combined Agents of America, please visit{' '}
            <a href="https://www.combinedagents.com">www.combinedagents.com</a>.
          </p>
          <p>
            We are excited about the opportunities this partnership presents and 
            are available to address any inquiries or feedback you may have.
          </p>
          <NavLink to={'/who-we-trust'} id={styles.homeBtn}>
            Back to Who We Trust
          </NavLink>
        </div>
      </ContentContainer>
    </div>
  );
};


export default PFSCombinedAgents;
